import { AccordionRadioGroup, Category } from '../../../../../types';
import { toOptions } from './toOptions';

export const toAccordionGroups = (data: Category[]): AccordionRadioGroup[] =>
  data.map((category) => ({
    icon: category.meta?.icon as string,
    label: category.title,
    options: toOptions(category.childCategories ?? []),
  }));
